var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{style:(_vm.cssProps)},[(_vm.getLoaderStatus && !_vm.getCompLoaderStatus)?_c('loader'):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }